<script>
import * as Common from './Common.js'

let loginEmail = '';
let sent = false;

function sendResetPasswordEmail() {
    Common.postData('reset-password-request', loginEmail)
    .then(r => {
        if(!r.ok) {
            alert('Problem sending Reset Email. Please try again!')
            return
        }
        sent = true;
    })
}
</script>

{#if !sent}
    <h1>Reset Password</h1>
    <p>
        Please enter your email below and click submit.
    </p>
    <input type="email" placeholder="Email Address" bind:value={loginEmail}><br>
    <button on:click={sendResetPasswordEmail}>Submit</button>
{:else}
    Please check your email, you will receive the reset email within the next new minutes!
{/if}